import React from "react";

const CategorySelect = ({
    name,
    value,
    onChange,
    onBlur,
    error,
    touched,
    categories
}) => {

    const categoriesOptions = categories
        ? categories.split(";").map(item => item.trim())
        : [];

    const handleChange = (e) => {
        const upperValue = e.target.value;
        onChange({
            target: {
                name: name,
                value: upperValue
            }
        });
    };

    return (
        <select
            className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 
                bg-white bg-clip-padding border border-solid border-gray-300 rounded 
                transition ease-in-out m-0 focus:text-gray-700 focus:bg-white 
                focus:border-blue-600 focus:outline-none
                ${touched && error ? "border-red-500" : ""}
            `}
            name={name}
            value={value}
            onChange={handleChange}
            onBlur={onBlur}
        >
            <option value="">Selecione uma opção...</option>

            {categoriesOptions.map((grade, idx) => (
                <option key={idx} value={grade}>
                    {grade}
                </option>
            ))}
        </select>
    );
};

export default CategorySelect;
